import { useNavigate as useNavigateReactRouter } from "react-router-dom";
import { CheckedLink } from "./routeGenerator";

export function useNavigate() {
    const navigateReactRouter = useNavigateReactRouter();
    const navigate = (link: CheckedLink) => {
        return navigateReactRouter(link.path);
    };
    return navigate;
}
